module.exports = __webpack_public_path__ + "img/logo-full.1bb11bb9.svg";